import { useLayoutEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';

class MainStore extends BaseStore {
  use() {
    super.use();
    useLayoutEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, []);
  }
}

export default MainStore;
